export default "__VITE_ASSET__B5z1TKtr__"